// Static enums used across onboarding, meal cards, and shopping list UI.
// Kept here (not on the server) because they're presentational labels —
// no proprietary logic. The server's source of truth for cuisine IDs and
// diet IDs must match the strings used here; see server/data/cuisineMeta.js.

export const ALLERGENS = [
  "Shellfish", "Fish", "Gluten", "Dairy", "Peanut",
  "Tree Nut", "Soy", "Egg", "Sesame", "Mustard", "Sulfite", "Nightshade",
];

export const DIETS = [
  { id: "classic",      label: "Classic",      desc: "No holds barred",         emoji: "🍽️" },
  { id: "lowcarb",      label: "Low Carb",     desc: "Reduced carbohydrates",   emoji: "🥗" },
  { id: "keto",         label: "Keto",         desc: "High fat, very low carb", emoji: "🥑" },
  { id: "flexitarian",  label: "Flexitarian",  desc: "Mostly plant-based",      emoji: "🌿" },
  { id: "paleo",        label: "Paleo",        desc: "Whole foods, no grains",  emoji: "🦴" },
  { id: "vegetarian",   label: "Vegetarian",   desc: "No meat or fish",         emoji: "🥦" },
  { id: "pescatarian",  label: "Pescatarian",  desc: "Fish but no meat",        emoji: "🐟" },
  { id: "vegan",        label: "Vegan",        desc: "100% plant-based",        emoji: "🌱" },
];

export const CUISINES = [
  { id: "french",         label: "French-inspired",         emoji: "🥐",  desc: "Elegant, rich & classic"        },
  { id: "italian",        label: "Italian-inspired",        emoji: "🍝",  desc: "Hearty, comforting & fresh"     },
  { id: "chinese",        label: "Chinese-inspired",        emoji: "🥢",  desc: "Bold, aromatic & varied"        },
  { id: "japanese",       label: "Japanese-inspired",       emoji: "🍱",  desc: "Clean, precise & umami"         },
  { id: "cambodian",      label: "Cambodian-inspired",      emoji: "🌿",  desc: "Fragrant, fresh & unique"       },
  { id: "thai",           label: "Thai-inspired",           emoji: "🌶️", desc: "Sweet, sour, salty, spicy"       },
  { id: "vietnamese",     label: "Vietnamese-inspired",     emoji: "🍲",  desc: "Light, herby & bright"          },
  { id: "korean",         label: "Korean-inspired",         emoji: "🍚",  desc: "Fermented, savoury & punchy"    },
  { id: "indian",         label: "Indian-inspired",         emoji: "🍛",  desc: "Layered spices & slow-built"    },
  { id: "mexican",        label: "Mexican-inspired",        emoji: "🌮",  desc: "Smoky, zingy & bold"            },
  { id: "spanish",        label: "Spanish-inspired",        emoji: "🥘",  desc: "Paprika, olive oil & share"     },
  { id: "greek",          label: "Greek-inspired",          emoji: "🫒",  desc: "Lemon, oregano & the sea"       },
  { id: "middle_eastern", label: "Middle Eastern-inspired", emoji: "🥙",  desc: "Herbs, tahini & char"           },
  { id: "american",       label: "American-inspired",       emoji: "🍔",  desc: "Big flavour, bigger comfort"    },
  { id: "british",        label: "British-inspired",        emoji: "🥧",  desc: "Hearty, traditional & seasonal" },
];

export const DISLIKE_OPTIONS = [
  "avocado", "beef", "beets", "bell peppers", "blue cheese", "brussels sprouts",
  "cauliflower", "eggplant", "eggs", "goat cheese", "lamb", "mushrooms", "olives",
  "pork", "quinoa", "salmon", "shrimp", "tofu", "tuna", "turnips", "anchovies",
  "liver", "offal", "oysters", "crab",
];

// Notes shown when a restrictive diet has limited options in a cuisine.
// Keys are cuisine IDs; inner keys are diet IDs.
export const CUISINE_DIET_NOTES = {
  cambodian: {
    vegan: "Cambodian cuisine is traditionally meat and fish-forward. We've found plant-based dishes that stay true to its lemongrass and kroeung flavour profile.",
    vegetarian: "Cambodian vegetarian options capture the cuisine's signature fragrant herbs, palm sugar and lime notes without meat.",
    keto: "Many Cambodian dishes are rice-heavy. These adapted recipes reduce carbs while preserving authentic flavours.",
  },
  chinese: {
    vegan: "Several classic Chinese dishes are naturally plant-based — tofu, mushrooms and vegetables shine in this cuisine.",
  },
};

export const CATEGORY_ICONS = { Proteins: "🥩", Produce: "🥦", Dairy: "🧀", Pantry: "🫙", Herbs: "🌿" };
export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
